"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitChatHistory = void 0;
class VisitChatHistory {
}
exports.VisitChatHistory = VisitChatHistory;
